export default {
    methods: {
        /*
        Takes as input an array of members, represented by an object
        with name and uid of the member.

        It returns an array of objects with id, inital letter
        and name of the members
        */
        getMembersToShow: function (membersNames) {
            let membersToShow = [];

            if (membersNames.length < 3) {
                for (let i = 0; i < membersNames.length; i++) {
                    let initalLetter = membersNames[i].name[0].toUpperCase();
                    membersToShow.push({
                        initalLetter: initalLetter,
                        name: this.getName(membersNames[i]),
                        id: "circle-" + Math.floor(Math.random() * 1000).toString()
                    });
                }
            } else {
                let allNames = "";
                for (let j = 0; j < membersNames.length; j++) {
                    if (j == 0) {
                        allNames = this.getName(membersNames[j]);
                    } else {
                        allNames = allNames + ",\n" + this.getName(membersNames[j]);
                    }
                }

               
                for (let i = 0; i < 2; i++) {
                    let initalLetter = membersNames[i].name[0].toUpperCase();
                    membersToShow.push({
                        initalLetter: initalLetter,
                        name: this.getName(membersNames[i]),
                        id: "circle-" + Math.floor(Math.random() * 1000).toString()
                    });
                }

                membersToShow.push({
                    initalLetter: "+" + (membersNames.length - 2).toString(),
                    name: allNames,
                    id: "circle-" + Math.floor(Math.random() * 1000).toString()
                });
            }
            return membersToShow;
        },
        getName: function(user) {
            if(user.surname){
                return user.name + " " + user.surname
            } else {
                return user.name
            }
        }
    }
};